/** @jsx jsx */
import React from 'react';
import { NavLink as Navlink } from 'react-router-dom';

import { jsx } from '@emotion/core';
import { Fragment } from 'react';
import { Helmet } from 'react-helmet';

import { OfficeLoactions } from '../../pages/ContactUs';
import {
  contactDetailStyles,
  FbBackground,
  FBLowerSection,
  FBMotif,
  FBSuccessWrap,
  iconStyles,
  lovetohearMessage,
  mapStyles,
  textWrap,
} from './contactUsStyles';
import { buttonS, buttonArrow } from './contactFormStyles';
import { MobilePhoneIcon, LetterIcon, CheckCircle, RightArrow } from '../ui/icons';
import Image from '../ui/Image';
// import { HubSpotScript } from '../components/ui/hubspotHook';

export default function ContactUs() {
  return (
    <Fragment>
      <Helmet>
        <title>Madison SPECS | Form Submitted</title>
        <meta name='description' content='Form Success' />
      </Helmet>
      <div css={{ position: 'relative', overflow: 'hidden' }}>
        <FBSuccessWrap>
          {/* <FbBackground /> */}
          <div className='fbbgc'>
            <FbBackground />
            <FBMotif />
          </div>
          <div className='fbWrap'>
            <div className='fb-contact'>Contact Us</div>
            <div className='fb-floating-box'>
              {/* <CheckCircle /> */}
              <img
                src='https://res.cloudinary.com/dyuuf6gor/image/upload/v1747159403/specs/633_a6br2t.svg'
                alt=''
                className='fb-check-circle'
              />
              <div className='fb-thankee'>Thank you for contacting Madison specs</div>
              <div className='fb-be-back'>We will get back to you shortly</div>

              <Navlink to='/'>
                <div css={buttonS} className='fb-home'>
                  Back to home page
                  <span css={buttonArrow}>
                    <RightArrow />
                  </span>
                </div>
              </Navlink>
            </div>
          </div>
        </FBSuccessWrap>
        <FBLowerSection>
          <div css={lovetohearMessage} className='fb-contact'>
            <div css={textWrap} className='fb-textWrap'>
              <div className='syne'>We'd love to hear from you.</div>
            </div>
            <div css={contactDetailStyles}>
              <div css={{ zIndex: 200, position: 'relative' }}>
                <div css={iconStyles}>
                  <span css={{ marginRight: 24 }}>
                    <MobilePhoneIcon />
                  </span>
                  <a href='tel:8887732773'>888-773-2773</a>
                </div>
                <div css={[iconStyles, { marginTop: 24 }]}>
                  <span css={{ marginRight: 24 }}>
                    <LetterIcon />
                  </span>
                  <a href='mailto:info@madisonspecs.com'>info@madisonspecs.com</a>
                </div>
              </div>
              <OfficeLoactions />
            </div>
          </div>
          <Image image='/specs/usa-map_rgv4bs.png' styles={mapStyles} />
        </FBLowerSection>
      </div>
    </Fragment>
  );
}
